import { axiosApi } from "../../../../../api/dbAxios";

export const deleteNotification = async (id: number) => {
  try {
    const response = await axiosApi.delete(`/notifications/${id}/`);
    return response.data;
  } catch (error: any) {
    throw error.response.data.detail;
  }
};
